export default "__VITE_ASSET__dyJO0J14__"